import React from "react";
import Badge from "@/components/ui/badge";
import ClickableTooltip from "@/components/controls/ClickableTooltip";

const BADGE_CLASSNAME =
  "border-border-badge-default bg-surface-badges-default py-1 px-[5px]";

interface Props {
  values: string[];
}

const MultiSelectBadgesCell: React.FC<Props> = ({ values }) => {
  const [first, second, ...rest] = values;
  const firstTwo = [first, second].filter(Boolean);
  const remaining = rest;

  return (
    <div className="flex gap-1 items-center">
      {firstTwo.map((value, index) => (
        <Badge
          key={`${value}-${index}`}
          text={value}
          textVariant="smBodySecondary"
          className={BADGE_CLASSNAME}
        />
      ))}
      {remaining?.length > 0 && (
        <ClickableTooltip
          trigger={
            <Badge
              text={`+${remaining.length}`}
              textVariant="smBodySecondary"
              className={BADGE_CLASSNAME}
            />
          }
          content={
            <div className="flex flex-col gap-1">
              {remaining.map((value, index) => (
                <Badge
                  key={`${value}-${index}`}
                  text={value}
                  textVariant="smBodySecondary"
                  className={BADGE_CLASSNAME}
                />
              ))}
            </div>
          }
        />
      )}
    </div>
  );
};

export default MultiSelectBadgesCell;
